/** True when a task group is the Design section (not Preconstruction / Production / etc.). */
export function isDesignGroupName(name: string | undefined | null): boolean {
  const n = (name || '').trim().toLowerCase();
  return n === 'design' || n.startsWith('design ');
}
